// extracted by mini-css-extract-plugin
export var notificationHost = "_ks-0";